import React, { useState } from 'react';
import classes from '../ClassPage.module.scss';
import { Button } from 'grommet';
import CancelAttendanceOrClass from '../../ActionButtons/CancelAttandanceOrClass/CancelAttendanceOrClass';
import ActivateClass from '../../ActionButtons/ActivateClass/ActivateClass';
import ExportToCSV from '../../AdminDashboard/ExportToCSV/ExportToCSV';
import Modal from 'react-modal';
import AddEditSingleClass from '../../AddEditSingleClass/AddEditSingleClass';

const ClassActionButtons = ({ isAdmin, classConfig, userData, singleClass }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div>
      <Modal isOpen={showModal} className="ss-modal" onRequestClose={() => setShowModal(false)}>
        <div className="grommet">
          <AddEditSingleClass
            classType={singleClass.__t}
            classConfig={classConfig}
            selectedClass={singleClass}
            onClose={() => setShowModal(false)}
          />
        </div>
      </Modal>
      <div>
        <div className={classes.flex}>
          <Button label="Edit" onClick={() => setShowModal(true)} data-cy="editBtn" />
          {isAdmin && (
            <CancelAttendanceOrClass
              cancelType="singleClass"
              type={'cancelClassButton'}
              selectedClass={singleClass}
              user={userData}
              attendance={singleClass.attendanceList}
            />
          )}
          {isAdmin && !singleClass.active && <ActivateClass classId={singleClass._id} />}
        </div>
        <ExportToCSV data={singleClass} type={'classDetail'} gymName={singleClass.gymId.name} />
      </div>
    </div>
  );
};

export default ClassActionButtons;
